module.exports = __webpack_public_path__ + "static/img/product_banner_04_zh.62bcea1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_04_zh.png
// module id = A3Yx
// module chunks = 34